import { atom } from 'recoil'
import { keyFactory } from 'src/utils/recoil'

export type UserModalState = {
  id?: string
  name?: string
  description?: string
}

const key = keyFactory('user-list-modal')

export const state = atom<UserModalState | null>({
  key: key('state'),
  default: null,
})
